export const paths = {
  mockup: (slug: string, mockupId: number | string) => `/mockup/${slug}/${mockupId.toString()}`,
};
